<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<section class="example-section">
  <mat-progress-bar class="example-margin" [color]="color" [mode]="mode" [value]="progresBarValue"
    [bufferValue]="bufferValue">
  </mat-progress-bar>
</section>
<div class="container design-overview-wrapper">
  <form focusInvalidInput class="form" (ngSubmit)="equipmentForm.form.valid && save()" #equipmentForm="ngForm">
    <h2> {{ !equipmentEditMode ? 'New Equipment':'Edit Equipment'}}</h2>
    <hr>
    <div class="breadcrumb">
      <ul class="d-flex align-items-center breadcrumb__list">
        <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link" routerLink="/home">Home</a>
        </li>
        <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link">
            {{ !equipmentEditMode ? 'New Equipment':'Edit Equipment'}}</a>
        </li>
      </ul>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">

          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">Equipment Name <i style="color:red;">*</i></p>
          </div>

          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="text" [(ngModel)]="equipment.equipmentname" (blur)="validateInputs()"
              name="equipmentname" [ngModelOptions]="{standalone: false}" class="example-right-align"
              placeholder="Equipment Name" #equipmentname="ngModel" required>
          </mat-form-field>
          <mat-error class='loadErrors' *ngIf="equipmentForm.submitted && equipmentname.errors?.required"> Equipment Name Is Required
          </mat-error>
        </div>

        <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
          <p class="design-overview-wrapper__item__title">Equipment Description</p>
          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="text" [(ngModel)]="equipment.equipmentdescription" name="equipmentdescription"
              [ngModelOptions]="{standalone: false}" (blur)="validateInputs()" class="example-right-align"
              placeholder="Equipment Description">
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex mb-3">
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Equipment Type
          </p>
        </div>
      </div>
      <mat-radio-group name="equipType" [(ngModel)]="equipment.equiptype" [ngModelOptions]="{standalone: false} "
        (change)="validateInputs()">
        <mat-radio-button value="Cooling-only air conditioner" checked="true" class="me-3">Cooling-only air conditioner
        </mat-radio-button>
        <mat-radio-button value="Cooling & heating heat pump" class="me-3">Cooling &
          heating heat pump </mat-radio-button>
          <mat-radio-button value="Ground source heat pump" class="me-3">Ground source heat pump </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="design-overview-wrapper__item" style="display:none;">
      <div class="d-flex mb-3">
        <div class="pe-3">
          <div class="design-overview-wrapper__item__item-number ">
            4 <div class="right">
            </div>
          </div>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Air Conditioner / Heat Pump (Complete if air conditioner or heat pump will be installed)</p>
        </div>
      </div>
    </div>


    <div class="design-overview-wrapper__item">
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number ">
                4.3
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Condenser Manufacturer <i style="color:red;">*</i></p>
            </div>
          </div>
          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="text" [(ngModel)]="equipment.condmfr" (blur)="validateInputs()"
              [ngModelOptions]="{standalone: false}" name="condmfr" class="example-right-align"
              placeholder="Condenser Manufacturer" #condmfr='ngModel' required>
          </mat-form-field>
          <mat-error class='loadErrors' *ngIf="equipmentForm.submitted&& condmfr.errors?.required"> Condenser Manufacturer Is Required
          </mat-error>
        </div>
        <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
          <p class="design-overview-wrapper__item__title">Condenser Model Number <i style="color:red;">*</i></p>
          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="text" [(ngModel)]="equipment.condensermn" (blur)="validateInputs()"
              [ngModelOptions]="{standalone: false}" name="condensermn" class="example-right-align"
              placeholder="Condenser Model Number" #condensermn='ngModel' required>
          </mat-form-field>
          <mat-error class='loadErrors' *ngIf="equipmentForm.submitted&& condensermn.errors?.required"> Condenser Model Number Is Required
          </mat-error>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number ">
                4.4
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Evaporator Manufacturer
              </p>
            </div>

          </div>
          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="text" [(ngModel)]="equipment.evapmfr" (blur)="validateInputs()"
              [ngModelOptions]="{standalone: false}" name="evapmfr" class="example-right-align"
              placeholder="Evaporator Manufacturer">
          </mat-form-field>
        </div>
        <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
          <p class="design-overview-wrapper__item__title">Evaporator Model Number
          </p>
          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="text" [(ngModel)]="equipment.evapmn" (blur)="validateInputs()"
              [ngModelOptions]="{standalone: false}" name="evapmn" class="example-right-align" placeholder="Evaporator Model Number
          ">
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number tooltip">
            4.5
          </span>
        </div><sup class='supTooltip tooltip'><div class="right">
          <h3>27.</h3>
          <p>If an AHRI Reference # is not available, OEM-provided documentation shall be emailed to <b>beth@theperformancepoint.com</b> with the rated
            efficiency of the specific combination of indoor & outdoor components of the air conditioner or heat
            pump, along with confirmation that the components are designed to be used together.</p>
        </div><b>?</b></sup>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">AHRI Reference #
          </p>
        </div>
      </div>
      <mat-form-field appearance="fill" floatLabel="always">
        <input matInput type="text" [(ngModel)]="equipment.ahrino" [ngModelOptions]="{standalone: false}"
          (blur)="validateInputs()" name="ahrino" class="example-right-align" placeholder="AHRI Reference">
      </mat-form-field>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex flex-wrap row">
        <div class="d-flex">
          <div class="pe-3">
            <span class="design-overview-wrapper__item__item-number ">
              4.6
            </span>
          </div>
          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">AHRI Listed Efficiency</p>
          </div>
        </div>
        <div class="d-flex flex-wrap">
          <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
            <p class="design-overview-wrapper__item__detail">EER (A/C)
            </p>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="number" [(ngModel)]="equipment.listedeer" [ngModelOptions]="{standalone: false}"
                (blur)="validateInputs()" name="listedeer" class="example-right-align" placeholder="EER (A/C)
            ">
            </mat-form-field>
          </div>
          <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
            <p class="design-overview-wrapper__item__detail">SEER (A/C)
            </p>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="number" [(ngModel)]="equipment.listedseer" [ngModelOptions]="{standalone: false}"
                (blur)="validateInputs()" name="listedseer" class="example-right-align" placeholder="SEER (A/C)
            ">
            </mat-form-field>
          </div>
          <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
            <p class="design-overview-wrapper__item__detail">HSPF (Heat Pump Heat)
            </p>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="number" [(ngModel)]="equipment.hpahrilistedhpsf"
                [ngModelOptions]="{standalone: false}" name="hpahrilistedhpsf" class="example-right-align" placeholder="HSPF (Heat Pump Heat)
            " (blur)="validateInputs()">
            </mat-form-field>
          </div>
          <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
            <p class="design-overview-wrapper__item__detail">COP (Ground Source Heat Pump)
            </p>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="number" [(ngModel)]="equipment.hp17fcop" [ngModelOptions]="{standalone: false}"
                (blur)="validateInputs()" name="hp17fcop" class="example-right-align" placeholder="COP (Ground Source Heat Pump)
            ">
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex mb-3">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number ">
            4.7
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Evaporator FanType
          </p>
        </div>
      </div>
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
          <mat-form-field appearance="fill">
            <mat-select placeholder="Select" [(ngModel)]="equipment.fanspeed" [ngModelOptions]="{standalone: false}"
              (ngModelChange)="validateInputs()" name="fanspeeds">
              <mat-option *ngFor="let fantype of fanTypes" [value]="fantype">
                {{fantype}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number ">
            4.8
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Compressor Type
          </p>
        </div>
      </div>
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
          <mat-form-field appearance="fill">
            <mat-select placeholder="Select" [(ngModel)]="equipment.compressortype" (ngModelChange)="validateInputs()"
              [ngModelOptions]="{standalone: false}" name="Compressor">
              <mat-option *ngFor="let compressor of compressorTypes" [value]="compressor">
                {{compressor}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number ">
            4.9
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Listed System Latent Capacity at Design Condition
          </p>
        </div>
      </div>
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="number" [(ngModel)]="equipment.latentdescap" [ngModelOptions]="{standalone: false}"
              (blur)="validateInputs()" name='latentdescap' class="example-right-align" placeholder="0">
            <span matSuffix>kBtuh</span>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number ">
            4.10
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Listed System Sensible Capacity at Design Condition
          </p>
        </div>
      </div>
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="number" [(ngModel)]="equipment.sensibledescap" [ngModelOptions]="{standalone: false}"
              (blur)="validateInputs()" name='sensibledescap' class="example-right-align" placeholder="0">
            <span matSuffix>kBtuh</span>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            4.11
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Listed System Total Capacity at Design Condition
          </p>
        </div>
      </div>
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="number" [(ngModel)]="equipment.totaldescap" [ngModelOptions]="{standalone: false}"
              (blur)="validateInputs()" name='totaldescap' class="example-right-align" placeholder="0">
            <span matSuffix>kBtuh</span>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
          <div class="d-flex">
            <div class="pe-3">
              <span class="design-overview-wrapper__item__item-number">
                4.12
              </span>
            </div>
            <div class="ps-3">
              <p class="design-overview-wrapper__item__title">Performance at 17F:</p>
            </div>
          </div>
        </div>
        <div class="d-flex-flex-wrap row">
          <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
            <p class="design-overview-wrapper__item__detail">Capacity
            </p>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="number" [(ngModel)]="equipment.hp17fcap" [ngModelOptions]="{standalone: false}"
                name='hp17fcap' class="example-right-align" placeholder="0" (blur)="validateInputs()">
              <span matSuffix>kBtuh</span>
            </mat-form-field>
          </div>
        </div>
        <div class="d-flex">
          <div class="pe-3">
            <span class="design-overview-wrapper__item__item-number">
              4.12
            </span>
          </div>
          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">Performance at 47F:</p>
          </div>
        </div>
        <div class="d-flex flex-wrap row">
          <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
            <p class="design-overview-wrapper__item__detail">Capacity
            </p>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="text" [(ngModel)]="equipment.hp47fcap" [ngModelOptions]="{standalone: false}"
                name='hp47fcap' class="example-right-align" placeholder="0" (blur)="validateInputs()">
              <span matSuffix>kBtuh</span>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="design-overview-wrapper__item">
        <div class="d-flex">
          <div class="pe-3">
            <span class="design-overview-wrapper__item__item-number tooltip">
              4.14 <div class="right">
                <h3>28.</h3>
                <p>Per ACCA Manual S, Second Edition, if the load sensible heat ratio is ≥ 95% and the HDD/CDD ratio is
                  ≥ 2.0, then the Climate is Condition B, otherwise it is Condition A.</p>
              </div>
            </span>
          </div><sup class='supTooltip tooltip'><div class="right">
            <h3>28.</h3>
            <p>Per ACCA Manual S, Second Edition, if the load sensible heat ratio is ≥ 95% and the HDD/CDD ratio is
              ≥ 2.0, then the Climate is Condition B, otherwise it is Condition A.</p>
          </div><b>?</b></sup>
          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">HDD/CDD ratio (select a county from dropdown, and the
              HDD/CDD ratio will be saved)
              <!--<span (click)="showHideHDDCDD()" class="na">N/A</span> -->
            </p>
          </div>
        </div>
        <div class="d-flex flex-wrap row">
          <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">

            <!--
            <p class="design-overview-wrapper__item__detail" *ngIf="selectedRegion==''"> <b>{{!isShowSeasonSection ?
                '0':
                ''}}</b>
            </p>
            <p  style='display:none;' class="design-overview-wrapper__item__detail" *ngIf="selectedRegion!=''"> {{selectedRegion}}
            </p>
            -->
            <p class="design-overview-wrapper__item__detail">County</p>

            <div class="d-flex flex-wrap row" *ngIf="isShowSeasonSection" style="position: relative;top: -26px;">

              <mat-form-field appearance="fill" style="position: relative;top: 27px;">
                <mat-select placeholder="Select" [(ngModel)]="selectedSeason" [ngModelOptions]="{standalone: true} "
                  (ngModelChange)="validateInputs()" name="season" (ngModelChange)="changeSeason()">
                  <mat-option *ngFor="let season of seasons" [value]="season.temp_id">
                    {{season.county}} - {{season.state}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative" *ngIf="isShowSeasonSection">
            <p class="design-overview-wrapper__item__detail">Ratio
            </p>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="number" readonly [(ngModel)]="equipment.ratercompid"
                [ngModelOptions]="{standalone: true}" name='ratercompid' class="example-right-align disabled"
                placeholder="0">
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="design-overview-wrapper__item">
        <div class="d-flex flex-wrap row">
          <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
            <div class="d-flex">
              <div class="pe-3">
                <span class="design-overview-wrapper__item__item-number ">
                  4.17
                </span>
              </div>
              <div class="ps-3">
                <p class="design-overview-wrapper__item__title">Furnace Manufacturer<i
                    *ngIf="equipment?.furnacemn?.length > 0 " style="color:red;">*</i>
                </p>
              </div>
            </div>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="text" [(ngModel)]="equipment.furnmfre" [ngModelOptions]="{standalone: false}"
                name="furnmfre" class="example-right-align" (blur)="validateInputs()" placeholder="Furnace Manufacturer"
                [required]="equipment?.furnacemn?.length > 0 ? true : false" #furnmfre="ngModel">
            </mat-form-field>
            <mat-error *ngIf="furnmfre.errors?.required"> Furnace Manufacturer Is Required
            </mat-error>
          </div>
          <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
            <p class="design-overview-wrapper__item__title">Furnace Model Number<i
                *ngIf="equipment?.furnmfre?.length > 0 " style="color:red;">*</i></p>
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="text" class="example-right-align"
                [required]="equipment?.furnmfre?.length > 0 ? true :false" [(ngModel)]="equipment.furnacemn"
                (blur)="validateInputs()" [ngModelOptions]="{standalone: false}" name="furnacemn"
                placeholder="Furnace Model Number" #furnacemn='ngModel'>
            </mat-form-field>
            <mat-error *ngIf="furnacemn.errors?.required"> Furnace Model Number Is Required
            </mat-error>
          </div>
        </div>

      </div>
      <div class="design-overview-wrapper__item">
        <div class="d-flex">
          <div class="pe-3">
            <span class="design-overview-wrapper__item__item-number ">
              4.18
            </span>
          </div>
          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">Listed Efficiency: (AFUE)
            </p>
          </div>
        </div>
        <div class="d-flex flex-wrap row">
          <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="number" [(ngModel)]="equipment.listedafue" [ngModelOptions]="{standalone: false}"
                (blur)="validateInputs()" name="listedafue" class="example-right-align" placeholder="Listed Efficiency: (AFUE)
      ">
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="design-overview-wrapper__item">
        <div class="d-flex">
          <div class="pe-3">
            <span class="design-overview-wrapper__item__item-number ">
              4.19
            </span>
          </div>
          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">Listed Output Heating Capacity:
            </p>
          </div>
        </div>
        <div class="d-flex flex-wrap row">
          <div class="d-flex mb-3 col-md-6 flex-column px-3 position-relative">
            <mat-form-field appearance="fill" floatLabel="always">
              <input matInput type="number" [(ngModel)]="equipment.furnoutput" [ngModelOptions]="{standalone: false}"
                (blur)="validateInputs()" name="furnoutput" class="example-right-align" placeholder="0">
              <span matSuffix>kBtuh</span>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="design-overview-wrapper__item">
        <div class="d-flex">
          <div class="ps-3">
            <p class="design-overview-wrapper__item__title" style="color:red;">* Required fields
            </p>
          </div>
        </div>
      </div>
      <div class="d-flex my-3 me-3">
        <button mat-flat-button class="me-3" color="primary">{{!equipmentEditMode ?
          'Save' : 'Update'}}</button>
        <button mat-flat-button color="warn" type="button" [routerLink]="['/equipment']" data-toggle="collapse"
          data-target="#dds3" aria-expanded="false" aria-controls="dds3">
          Cancel
        </button>
      </div>

    </div>
  </form>
</div>
